import { render, staticRenderFns } from "./peie.vue?vue&type=template&id=9345fafa&scoped=true"
import script from "./peie.vue?vue&type=script&lang=js"
export * from "./peie.vue?vue&type=script&lang=js"
import style0 from "./peie.vue?vue&type=style&index=0&id=9345fafa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9345fafa",
  null
  
)

export default component.exports